module.exports = __webpack_public_path__ + "img/paishui.8b3475de.png";